@if(loading?.page){
<app-loader [type]="'Page'"></app-loader>
}@else{
@if(orgForm){
<div class="org-setup-container vh-100 overflow-auto" fxLayout="row" fxLayoutAlign="center start">
  <div class="card main-card">
    <div class="card-header bg-white py-4 position-relative" fxLayout="row" fxLayoutAlign="center center">
      <h4 class="m-0 title-text fw-normal">Welcome {{customerDetails?.accountOwner?.name}}!</h4>
      <div class="position-absolute end-0 pe-4" routerLink="/signin" title="Logout" data-control="logout">
        <i class="bi bi-power logout-icon"></i>
      </div>
    </div>
    <div class="p-4">
      <div class="mb-3">
        <h5 class="mb-1 text-dark fw-normal">Let's get started</h5>
        <div class="text-muted small-text">Tell us a bit about your organization.</div>
      </div>
      <form [formGroup]="orgForm" fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="column">
          <label for="name">Organization Name</label>
          <input type="text" class="form-control" formControlName="name" data-control="name">
          @if(orgForm?.get('name')?.hasError('required') && orgForm?.get('name')?.touched) {
          <small class="error-msg" data-control="name-req">{{messages?.FIELD_REQUIRED}}</small>
          }
        </div>
        <div fxLayout="column">
          <label for="industryId">Industry</label>
          <ng-select [items]="industryDetails" formControlName="industryId" bindLabel="name" bindValue="id"
            [hideSelected]="false" [clearable]="false" data-control="industryId"></ng-select>
          @if(orgForm.get('industryId')?.hasError('required') && orgForm.get('industryId')?.touched) {
          <small class="error-msg" data-control="industryId-req">{{messages?.FIELD_REQUIRED}}</small>
          }
        </div>
        <div fxLayout="column" fxLayoutGap="20px" class="mt-3">
          <div class="mb-3">
            <div class="mb-1 text-dark fw-normal">Organization Address</div>
            <div class="text-muted subtext">This is your primary place of work. We will use this address for
              further reference!</div>
          </div>
          <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="24px">
            <div fxFlex="50" fxLayout="column">
              <input type="text" class="form-control" formControlName="address" placeholder="Address"
                data-control="address">
              @if(orgForm.get('address')?.hasError('required') && orgForm.get('address')?.touched) {
              <small class="error-msg" data-control="address-req">{{messages?.FIELD_REQUIRED}}</small>
              }
            </div>
            <div fxFlex="50" fxLayout="column">
              <input type="text" class="form-control" formControlName="city" placeholder="City" data-control="city">
              @if(orgForm.get('city')?.hasError('required') && orgForm.get('city')?.touched) {
              <small class="error-msg" data-control="city-req">{{messages?.FIELD_REQUIRED}}</small>
              }
            </div>
          </div>
          <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="24px">
            <div fxFlex="50" fxLayout="column">
              <ng-select [items]="countries" formControlName="country" bindLabel="item" bindValue="item"
                placeholder="Country" [hideSelected]="false" [clearable]="false" data-control="country"></ng-select>
              @if(orgForm.get('country')?.hasError('required') && orgForm.get('country')?.touched)
              {
              <small class="error-msg" data-control="country-req">{{messages?.FIELD_REQUIRED}}</small>
              }
            </div>
            <div fxFlex="50" fxLayout="column">
              <ng-select [items]="states" formControlName="state" bindLabel="item" bindValue="item" placeholder="State"
                [hideSelected]="false" [clearable]="false" data-control="state"></ng-select>
              @if(orgForm.get('state')?.hasError('required') && orgForm.get('state')?.touched) {
              <small class="error-msg" data-control="state-req">{{messages?.FIELD_REQUIRED}}</small>
              }
            </div>
          </div>
          <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="24px">
            <div fxFlex="50" fxLayout="column">
              <input type="text" class="form-control" formControlName="zipcode" placeholder="Zipcode"
                data-control="zipcode">
              @if(orgForm.get('zipcode')?.hasError('required') && orgForm.get('zipcode')?.touched)
              {
              <small class="error-msg" data-control="zipcode-req">{{messages?.FIELD_REQUIRED}}</small>
              }
            </div>
            <div fxFlex="50" fxLayout="column">
              <ng-select [items]="timezone" formControlName="timezoneId" bindLabel="name" bindValue="id"
                placeholder="Timezone" [hideSelected]="false" [clearable]="false" data-control="timezoneId"></ng-select>
              @if(orgForm.get('timezoneId')?.hasError('required') && orgForm.get('timezoneId')?.touched) {
              <small class="error-msg" data-control="timezoneId-req">{{messages?.FIELD_REQUIRED}}</small>
              }
            </div>
          </div>
        </div>
        <div class="mt-4" fxLayout="row" fxLayoutAlign="center center">
          <button type="submit" class="btn btn-primary" (click)="onSave()" data-control="save-btn"
            [ngClass]="{'disable-btn loading': loading.button }">
            @if(loading.button){
            <app-loader [type]="'Button'"></app-loader>
            }
            Save Details</button>
        </div>
      </form>
    </div>
  </div>
</div>
}
}